export default "skymp5-front/d9399632ac856cae4df7753feca6cc69.png";